export const PARTS_LOGS = () => '/parts/logs';
